import type { FaireProductEntity } from "../../entity_types/product";

export const p_m9x4rwq9v8: FaireProductEntity = {
  token: "p_m9x4rwq9v8",
  type: "product",
  name: "Candle Snuffer and Wick Trimmer",
  brandToken: "b_8aa5kchc2z",
  brandName: "Homecourt",
  imageUrl:
    "https://cdn.faire.com/fastly/dfc9249854646664843b3b7f81e197360dbf4a55bde7edc347a6191def5b0432.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4dbfa0a90c5cd0eab89915c13801be4f0d9e9d1596a784ac35e6645597c78e15.jpeg",
    "https://cdn.faire.com/fastly/0b7597ed56d7ac1bc45d6a0e80d08a204bbcd7af96048f2eecde76c46ec14328.jpeg",
  ],
  priceDollars: 19.8,
  description:
    "Elevate your candle ritual with Homecourt’s luxury Candle Accessory Duo, a premium candle care set designed to preserve the beauty and performance of your favorite candles. This two-piece set includes a candle snuffer and a wick trimmer, crafted with sleek, durable materials that are as stylish as they are functional.\n\nBy caring for your candles with the right tools, you’ll enjoy a cleaner, longer-lasting burn, reduced soot, and a more refined home fragrance experience. Elegant enough to display, this candle tool set is an essential addition to any luxury homecare routine.\n\nWhat’s Included\nCandle Snuffer – Extinguishes flames effortlessly, reducing smoke while preserving wax and wick integrity\nWick Trimmer – Precisely trims wicks to the optimal length for a clean, even burn\n\nWhy You’ll Love It\n-Complete candle care kit for extending candle life\n-Crafted with premium, durable materials\n-Reduces smoke, soot, and tunneling for a cleaner burn\n-Elegant design that doubles as a decorative accent\n-Pairs perfectly with Homecourt’s luxury Candle Collection\n\nHow to Use\nTrim candle wick to ¼ inch before each burn using the wick trimmer. To extinguish, place the snuffer over the flame until fully out—helping to minimize smoke and preserve the fragrance.\n\nPairing Recommendation\nUse with any of Homecourt’s Luxury Fine Fragrance Candles for the ultimate candle care and scenting ritual.\n",
  tags: [],
  msrpDollars: 36,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-04-28T15:36:24.188Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
